const riskScoreLetters = [
  {
    letter: 'a',
    color: '#29CE9C',
  },
  {
    letter: 'b',
    color: '#F0BF16',
  },
  {
    letter: 'c',
    color: '#FBA212',
  },
  {
    letter: 'd',
    color: '#FF7A03',
  },
  {
    letter: 'e',
    color: '#ED3D68',
  },
  {
    letter: 'f',
    color: '#E132A0',
  },
];
export default riskScoreLetters;
